import { LocationFormProps } from '../../types/calendar';

const US_STATES = [
  { value: 'Alabama', abbr: 'AL' },
  { value: 'Alaska', abbr: 'AK' },
  { value: 'Arizona', abbr: 'AZ' },
  { value: 'Arkansas', abbr: 'AR' },
  { value: 'California', abbr: 'CA' },
  { value: 'Colorado', abbr: 'CO' },
  { value: 'Connecticut', abbr: 'CT' },
  { value: 'Delaware', abbr: 'DE' },
  { value: 'District Of Columbia', abbr: 'DC' },
  { value: 'Florida', abbr: 'FL' },
  { value: 'Georgia', abbr: 'GA' },
  { value: 'Hawaii', abbr: 'HI' },
  { value: 'Idaho', abbr: 'ID' },
  { value: 'Illinois', abbr: 'IL' },
  { value: 'Indiana', abbr: 'IN' },
  { value: 'Iowa', abbr: 'IA' },
  { value: 'Kansas', abbr: 'KS' },
  { value: 'Kentucky', abbr: 'KY' },
  { value: 'Louisiana', abbr: 'LA' },
  { value: 'Maine', abbr: 'ME' },
  { value: 'Maryland', abbr: 'MD' },
  { value: 'Massachusetts', abbr: 'MA' },
  { value: 'Michigan', abbr: 'MI' },
  { value: 'Minnesota', abbr: 'MN' },
  { value: 'Mississippi', abbr: 'MS' },
  { value: 'Missouri', abbr: 'MO' },
  { value: 'Montana', abbr: 'MT' },
  { value: 'Nebraska', abbr: 'NE' },
  { value: 'Nevada', abbr: 'NV' },
  { value: 'New Hampshire', abbr: 'NH' },
  { value: 'New Jersey', abbr: 'NJ' },
  { value: 'New Mexico', abbr: 'NM' },
  { value: 'New York', abbr: 'NY' },
  { value: 'North Carolina', abbr: 'NC' },
  { value: 'North Dakota', abbr: 'ND' },
  { value: 'Ohio', abbr: 'OH' },
  { value: 'Oklahoma', abbr: 'OK' },
  { value: 'Oregon', abbr: 'OR' },
  { value: 'Pennsylvania', abbr: 'PA' },
  { value: 'Rhode Island', abbr: 'RI' },
  { value: 'South Carolina', abbr: 'SC' },
  { value: 'South Dakota', abbr: 'SD' },
  { value: 'Tennessee', abbr: 'TN' },
  { value: 'Texas', abbr: 'TX' },
  { value: 'Utah', abbr: 'UT' },
  { value: 'Vermont', abbr: 'VT' },
  { value: 'Virginia', abbr: 'VA' },
  { value: 'Washington', abbr: 'WA' },
  { value: 'West Virginia', abbr: 'WV' },
  { value: 'Wisconsin', abbr: 'WI' },
  { value: 'Wyoming', abbr: 'WY' },
];

const PHONE_FIELDS = new Set(['phone', 'cell_phone', 'fax']);

const KNOWN_PLACEHOLDERS: Record<string, string> = {
  agency_combine: 'Agency/Agent Name(s)',
  additional_agents: 'Other Agents or Info',
  address: 'Address or Other Info',
  city: 'City or Other Info',
  state: '--Select state--',
  zip_code: 'Zip Code',
  phone: 'Office Phone: (___) ___-____',
  cell_phone: 'Cell Phone: (___) ___-____',
  fax: 'Fax: (___) ___-____',
  other_info: 'Email/Web Address/Other Info',
};

// Default hardcoded order when no fields prop provided
const DEFAULT_FIELD_KEYS = [
  'agency_combine', 'additional_agents', 'address', 'city', 'state',
  'zip_code', 'phone', 'cell_phone', 'fax', 'other_info',
];

export function LocationForm({ location, onFieldChange, fields }: LocationFormProps) {
  const inputClass = 'w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent';

  const fieldKeys = fields ? fields.map(f => f.key) : DEFAULT_FIELD_KEYS;
  const fieldLabelMap: Record<string, string> = {};
  if (fields) {
    for (const f of fields) fieldLabelMap[f.key] = f.label;
  }

  return (
    <div className="space-y-3">
      {fieldKeys.map((key) => {
        const rawVal = location[key];
        const value = typeof rawVal === 'string' ? rawVal : (rawVal != null ? String(rawVal) : '');
        const placeholder = KNOWN_PLACEHOLDERS[key] || fieldLabelMap[key] || key;

        if (key === 'state') {
          return (
            <select
              key={key}
              value={value}
              onChange={(e) => onFieldChange(key, e.target.value)}
              className={inputClass}
            >
              <option value="">--Select state--</option>
              {US_STATES.map((s) => (
                <option key={s.abbr} value={s.abbr}>{s.value}</option>
              ))}
            </select>
          );
        }

        return (
          <input
            key={key}
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onFieldChange(key, e.target.value)}
            {...(PHONE_FIELDS.has(key) ? { inputMode: 'tel' as const } : {})}
            className={inputClass}
          />
        );
      })}
    </div>
  );
}
